export enum TooltipPosition {
  ABOVE = 'above',
  BELOW = 'below',
  BELOW_RIGHT = 'below-right',
  BELOW_LEFT = 'below-left',
  LEFT = 'left',
  DYNAMIC = 'dynamic',
  RIGHT = 'right',
}
